import React, { useState } from 'react';
import LeftImgSection from '../../../components/LeftImgSection/LeftImgSection';
import PropertyCard from '../../../components/PropertyCard/PropertyCard';
import './css/ListingSection.css';

const ListingSection = ({ listingData }) => {
  const { header = {}, properties = {} } = listingData;
  const propertiesArray = Object.values(properties);
  const itemsPerPage = 3;

  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(propertiesArray.length / itemsPerPage);

  const paginatedProperties = propertiesArray.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  const handleNext = () => {
    setCurrentPage((prev) => (prev + 1) % totalPages);
  };

  const handlePrev = () => {
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  };

  return (
    <section className="listing-section">
      <h1 className="sectionTitle">List of available properties</h1>
      <div className="headerSeparator"></div>
      <LeftImgSection
        title={header.listin_title || 'Default Title'}
        description={header.listin_description || 'Default Description'}
        img={header.listin_image || ''}
        button={header.button || null}
        darkMode={true}
      />
      <div className="separator"></div>
      <div className="property-cards horizontal-layout">
        {paginatedProperties.length > 0 ? (
          paginatedProperties.map((property, index) => (
            <PropertyCard key={index} property={property} />
          ))
        ) : (
          <p>No properties available.</p>
        )}
      </div>
      {totalPages > 1 && (
        <div className="carousel-controls">
          <button onClick={handlePrev}>&larr;</button>
          <span>{currentPage + 1} / {totalPages}</span>
          <button onClick={handleNext}>&rarr;</button>
        </div>
      )}
    </section>
  );
};

export default ListingSection;
